import http from '@/services/http';

const symbols = {
  index() {
    return http.request({
      method: 'get',
      url: '/symbols',
    });
  },
  autocompleteFetch(name) {
    const filter = {
      where: {
        name: { regexp: `/${name || ''}/i` },
      },
    };
    return http.request({
      method: 'get',
      url: '/symbols',
      params: { filter },
    });
  },
};

export default symbols;
